import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import BasicDetails from "./BasicDetails";
import InfoTabs from "../../common/components/InfoTabs";
import HelperIcon from "../../helper/components/HelperIcon";
import EditHistory from "../../region/components/EditHistory";
class PropertyInfo extends Component {
    state = {
        isloading: true,
        basicDetails: {
            name: "",
            description: "",
            notes: "",
            created_at: "",
            updated_at: "",
            properties: {},
            recommendation_props: {},
            normal_recommendation_props: {}
        },
        isHistory: false,
        showConfirmModalLog: false,
        selectedLog: "",
        logChanges: {},
        associated_changes: [],
        activeDetail: "chart"
    };

    componentDidMount = async () => {
        await this.refreshinfoDetails();
    };

    refreshinfoDetails = async () => {
        let propertyData = await this.props.getDataById();
        if (propertyData && propertyData.success) {
            this.setState({
                basicDetails: {
                    name: propertyData.name,
                    description: propertyData.description,
                    notes: propertyData.notes,
                    created_at: propertyData.created_at,
                    updated_at: propertyData.updated_at,
                    asset_props: propertyData.asset_props,
                    properties: propertyData.properties,
                    recommendation_props: propertyData.recommendation_props,
                    multi_recommendation_props: propertyData.multi_recommendation_props,
                    normal_recommendation_props: propertyData?.normal_recommendation_props || {},
                    bbi_props: propertyData?.bbi_bsi_props || {},
                    bsi_props: propertyData?.basic_props?.bsi || {},
                    bai_props: propertyData?.basic_props?.bai || {}
                },
                isloading: false,
                isHistory: false
            });
            const {
                match: {
                    params: { tab }
                }
            } = this.props;
            this.setState({ activeDetail: tab || "chart" });
        }
        return true;
    };
    setActiveTab = activeTab => {
        const {
            match: {
                params: { id }
            }
        } = this.props;
        this.setState({ activeDetail: activeTab });
        let tabKeyList = ["CA", "sortedRecommendations", "multiRecommendation", "normalRecommendation", "asset", "bbi", "bsi", "bai"];
        if (activeTab !== "chart") {
            this.props.history.push(`/chartProperties/info/${id}/${tabKeyList.includes(activeTab) ? activeTab : "chart"}`);
        } else {
            this.props.history.push(`/chartProperties/info/${id}`);
        }
    };

    render() {
        const { isLoading } = this.state;
        if (isLoading) {
            return null;
        }
        const {
            infoTabsData,
            keys,
            config,
            match: {
                params: { tab }
            },
            getAllPropertyLogs,
            logData,
            handlePerPageChangeHistory,
            handlePageClickHistory,
            handleGlobalSearchHistory,
            globalSearchKeyHistory,
            handleDeleteLog,
            handleRestoreLog,
            historyPaginationParams,
            historyParams,
            updateLogSortFilters,
            permissions,
            logPermission,
            hasDelete,
            hasEdit,
            hasLogView,
            hasLogDelete,
            hasLogRestore,
            hasInfoPage,
            selectedProperty,
            showEditPage,
            cancelForm,
            cancelInfoPage,
            isHistory,
            toggleHistory,
            entity
        } = this.props;
        const { basicDetails, activeDetail } = this.state;
        return (
            <React.Fragment>
                <div className="dtl-sec col-md-12">
                    <div className="tab-dtl region-mng">
                        <ul>
                            <li
                                className={
                                    !this.props.match.params.tab || this.props.match.params.tab === "basicdetails"
                                        ? "cursor-pointer active pl-4"
                                        : "cursor-pointer"
                                }
                                onClick={() => this.setActiveTab("chart")}
                            >
                                Chart
                            </li>
                            <li
                                className={this.props.match.params.tab === "CA" ? "cursor-pointer active pl-4" : "cursor-pointer"}
                                onClick={() => this.setActiveTab("CA")}
                            >
                                Comparative Analysis
                            </li>
                            <li
                                className={this.props.match.params.tab === "sortedRecommendations" ? "cursor-pointer active pl-4" : "cursor-pointer"}
                                onClick={() => this.setActiveTab("sortedRecommendations")}
                            >
                                Sorted Recommendations
                            </li>
                            <li
                                className={this.props.match.params.tab === "multiRecommendation" ? "cursor-pointer active pl-4" : "cursor-pointer"}
                                onClick={() => this.setActiveTab("multiRecommendation")}
                            >
                                Recommendation Summary
                            </li>
                            <li
                                className={this.props.match.params.tab === "normalRecommendation" ? "cursor-pointer active pl-4" : "cursor-pointer"}
                                onClick={() => this.setActiveTab("normalRecommendation")}
                            >
                                Recommendation Table
                            </li>
                            <li
                                className={this.props.match.params.tab === "asset" ? "cursor-pointer active pl-4" : "cursor-pointer"}
                                onClick={() => this.setActiveTab("asset")}
                            >
                                Asset Table
                            </li>
                            <li
                                className={this.props.match.params.tab === "bbi" ? "cursor-pointer active pl-4" : "cursor-pointer"}
                                onClick={() => this.setActiveTab("bbi")}
                            >
                                BBI
                            </li>
                            <li
                                className={this.props.match.params.tab === "bsi" ? "cursor-pointer active pl-4" : "cursor-pointer"}
                                onClick={() => this.setActiveTab("bsi")}
                            >
                                BSI
                            </li>
                            <li
                                className={this.props.match.params.tab === "bai" ? "cursor-pointer active pl-4" : "cursor-pointer"}
                                onClick={() => this.setActiveTab("bai")}
                            >
                                BAI
                            </li>
                            {/* <li className={activeDetail==="chartDataTable" ? " cursor-pointer active pl-4" :"cursor-pointer"}onClick={() => this.setActiveTab("chartDataTable")}>Image Gallery</li> */}
                        </ul>
                        <HelperIcon isHistory={isHistory} entity={isHistory ? "general" : entity} />
                        {isHistory ? (
                            <EditHistory
                                getAllRegionLogs={getAllPropertyLogs}
                                handlePerPageChangeHistory={handlePerPageChangeHistory}
                                handlePageClickHistory={handlePageClickHistory}
                                handleGlobalSearchHistory={handleGlobalSearchHistory}
                                globalSearchKeyHistory={globalSearchKeyHistory}
                                logData={logData}
                                handleDeleteLog={handleDeleteLog}
                                historyPaginationParams={historyPaginationParams}
                                handleRestoreLog={handleRestoreLog}
                                historyParams={historyParams}
                                updateLogSortFilters={updateLogSortFilters}
                                permissions={permissions}
                                hasLogDelete={hasLogDelete}
                                hasLogRestore={hasLogRestore}
                                hasEdit={hasEdit}
                                hasDelete={hasDelete}
                                columnConfig={config}
                                hasLogView={true}
                                changeToHistory={toggleHistory}
                            />
                        ) : (
                            <BasicDetails
                                keys={keys}
                                config={config}
                                basicDetails={basicDetails}
                                showEditPage={showEditPage}
                                isHistoryView={true}
                                changeToHistory={toggleHistory}
                                isHistory={isHistory}
                                permissions={permissions}
                                logPermission={logPermission}
                                hasEdit={hasEdit}
                                hasDelete={hasDelete}
                                hasLogView={hasLogView}
                                selectedProperty={selectedProperty}
                                cancelForm={cancelForm}
                                cancelInfoPage={cancelInfoPage}
                                entity={entity}
                                activeDetail={activeDetail}
                            />
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(PropertyInfo);
